'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minuteAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/minuteAfter.js
// module id = 704
// module chunks = 0